import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

import { InlineSvgComponent } from '../inline-svg/inline-svg.component';

@Component({
  selector: 'ui-button-close',
  imports: [ CommonModule, InlineSvgComponent ],
  templateUrl: './button-close.component.html',
  styleUrl: './button-close.component.scss',
})
export class ButtonCloseComponent {

  /** Defines the style of the button. */
  type = input<'primary' | 'invert' | 'info' | 'success' | 'warning' | 'error'>('primary');
  /** Defines the size of the button. */
  size = input<'smaller' | 'small' | 'medium' | 'large'>('small');
}
